<template>
  <v-select
    :value="value"
    :items="items"
    :label="$t('label.status')"
    hide-details
    :menu-props="{ 'min-width': '250px' }"
    @input="updateStatus"
  >
    <template #item="{item}">
      <span class="d-block w-100">{{ item.text }}</span>
      <div class="text-right">
        <v-icon
          small
          :color="colorForStatus(item.value)"
        >
          mdi-circle
        </v-icon>
      </div>
    </template>
    <template #append>
      <v-icon
        small
        class="mt-1"
        :color="colorForStatus(value)"
      >
        mdi-circle
      </v-icon>
    </template>
  </v-select>
</template>

<script setup lang="ts">
import { ReservationStatus } from '@/model/Reservation';
import { PropType } from 'vue';
import { colorForStatus } from '@/components/helpers/colors';
import { reservationStatusItems } from '@/util/status';

const props = defineProps({
  value: { type: Object as PropType<ReservationStatus>, required: true },
});

const items = reservationStatusItems();

const emit = defineEmits(['input']);

const updateStatus = (s: ReservationStatus) => {
  emit('input', s);
};

</script>
